import React from 'react';
import Reveal from '../ui/Reveal';
import Button from '../ui/Button';

const offers = [
  {
    label: 'Entry Point',
    title: 'Clarity Session',
    price: ' ',
    description: 'A 90-minute working diagnosis. Not a discovery call. You leave knowing exactly what is blocking growth and which path removes it.',
    buttonText: 'Book Now',
    link: 'https://topmate.io/mugdha_clarity90/2028348',
    dark: false,
  },
  {
    label: 'Done For You',
    title: 'The Clarity Build',
    price: '',
    description: 'Your GTM system built and handed over. Positioning, platform setup, content strategy, 90 days of content, and a conversion path. Built once. Runs without you selling manually every time.',
    buttonText: 'Start with a Clarity Session',
    link: 'https://topmate.io/mugdha_clarity90/2028348',
    dark: true,
  },
  {
    label: 'Done With You',
    title: 'Clarity90 Retainer',
    price: '',
    description: 'An embedded 90-day operating system for post-revenue founders whose effort and output have decoupled. Built inside your business, not handed over as a document.',
    buttonText: 'Start with a Clarity Session',
    link: 'https://topmate.io/mugdha_clarity90/2028348',
    dark: false,
  },
];

export default function Offers() {
  return (
    <section className="py-24 md:py-32 bg-[#F5EBE1] text-brand-deep">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <div className="text-center mb-16">
            <h2 className="font-serif text-4xl md:text-5xl mb-4">How We Work Together</h2>
            <p className="text-lg font-light text-brand-olive">Three paths to remove founder dependency.</p>
          </div>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-8">
          {offers.map((offer, i) => (
            <Reveal key={offer.title} delay={i * 0.1}>
              <div className={`h-full flex flex-col p-10 border transition-colors ${
                offer.dark
                  ? 'bg-brand-deep text-brand-cream border-brand-deep relative overflow-hidden'
                  : 'bg-white text-brand-deep border-brand-deep/5 hover:border-brand-terra/30'
              }`}>
                {offer.dark && (
                  <div className="absolute top-0 right-0 w-32 h-32 bg-brand-terra/10 rounded-full blur-3xl" />
                )}

                <span className={`text-sm tracking-widest uppercase mb-4 block relative z-10 ${
                  offer.dark ? 'text-brand-sand' : 'text-brand-mocha'
                }`}>
                  {offer.label}
                </span>

                <h3 className={`font-serif text-3xl mb-3 relative z-10 ${
                  offer.dark ? 'text-brand-cream' : 'text-brand-deep'
                }`}>
                  {offer.title}
                </h3>

                {offer.price && (
                  <p className={`text-sm font-medium mb-6 relative z-10 ${
                    offer.dark ? 'text-brand-sand' : 'text-brand-terra'
                  }`}>
                    {offer.price}
                  </p>
                )}

                <p className={`font-light leading-relaxed mb-10 flex-grow relative z-10 ${
                  offer.dark ? 'text-brand-cream/80' : 'text-brand-olive'
                } ${!offer.price ? 'mt-6' : ''}`}>
                  {offer.description}
                </p>

                <div className={`pt-8 mt-auto relative z-10 ${
                  offer.dark ? 'border-t border-brand-cream/10' : 'border-t border-brand-deep/10'
                }`}>
                  <Button
                    variant={offer.dark ? 'primary' : 'outlineDark'}
                    className="w-full"
                    onClick={() => window.open(offer.link, '_blank')}
                  >
                    {offer.buttonText}
                  </Button>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}